import * as ticketService from '../../services/ticket';
import { GET_RECOMMENDED_TICKETS } from '../actionTypes';
import { PENDING, FAILURE, SUCCESS } from '../../utils/status';

let TICKET_CACHE = {};
// 推荐poi门票
export function getRecommended(city_ids, poi_uids) {
  return function (dispatch) {
    dispatch({
      type: GET_RECOMMENDED_TICKETS,
      status: PENDING
    });

    // 做缓存
    let key = `${city_ids}-${poi_uids}`;
    if(TICKET_CACHE[key]){
      let data = TICKET_CACHE[key];
      dispatch({
        type: GET_RECOMMENDED_TICKETS,
        status: SUCCESS,
        data: data
      });
      return data;
    }

    return ticketService.getRecommended(city_ids, poi_uids)
      .then(function (data) {
        dispatch({
          type: GET_RECOMMENDED_TICKETS,
          status: SUCCESS,
          data: data
        });

        if(!TICKET_CACHE[key]){
          TICKET_CACHE[key] = data;
        }
        return data;
      })
      .catch(function (err) {
        dispatch({
          type: GET_RECOMMENDED_TICKETS,
          status: FAILURE,
          data: err
        });

        throw err;
      });
  };
}



// WEBPACK FOOTER //
// ./src/store/actions/ticket.js